function formatShortDate(date: Date): string {
	const now = new Date();
	const sameYear = date.getFullYear() === now.getFullYear();

	if (sameYear) {
		const monthDay = date.toLocaleDateString("en-US", {
			month: "short",
			day: "numeric",
		});
		return `${monthDay}.`;
	}

	return date.toLocaleDateString("en-US", {
		month: "short",
		day: "numeric",
		year: "numeric",
	});
}

function formatRelativeTime(dateInput: string): string {
	const date = new Date(dateInput);

	if (Number.isNaN(date.getTime())) {
		return "";
	}

	const diffMs = Date.now() - date.getTime();
	const diffSec = Math.floor(diffMs / 1000);
	const diffMin = Math.floor(diffSec / 60);
	const diffHours = Math.floor(diffMin / 60);

	if (diffSec < 60) {
		return "just now";
	}

	if (diffMin < 60) {
		return diffMin === 1 ? "1 min ago" : `${diffMin} mins ago`;
	}

	if (diffHours < 24) {
		return diffHours === 1 ? "1 hr ago" : `${diffHours} hrs ago`;
	}

	return formatShortDate(date);
}

export default formatRelativeTime;
